/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const DisconnectionType = {
    NotSpecified: 'NotSpecified',
    RemoteDisconnection: 'RemoteDisconnection',
    ManualDisconnection: 'ManualDisconnection',
} as const;
export type DisconnectionType = typeof DisconnectionType[keyof typeof DisconnectionType];

